/*
 * Public API Surface of pricelists
 */

export * from './pricelists-config';
